/**
 * How a subscriber's signup timestamp reads in the admin listing.
 *
 * Both the locale and the time zone are stated rather than left to the
 * browser. A UTC timestamp near midnight rendered in the reader's own zone
 * would show a different day depending on where the operator is sitting, and
 * two operators comparing the same list would disagree about when an address
 * signed up. The column is labelled UTC, so this formats in UTC.
 *
 * `en-GB` gives the unambiguous day-month-year order — `1 Sep 2026` cannot be
 * misread the way a numeric `09/01/2026` can.
 */
const FORMATTER = new Intl.DateTimeFormat("en-GB", {
  day: "numeric",
  month: "short",
  year: "numeric",
  timeZone: "UTC",
});

/** What an unparseable timestamp renders as, rather than "Invalid Date". */
const UNKNOWN_DATE = "—";

/**
 * Format an ISO 8601 timestamp for the listing, or an em dash if it will not
 * parse — the value arrives off the wire, and a row with a broken timestamp
 * should still show the address it is about.
 */
export function formatSignupDate(isoTimestamp: string): string {
  const parsed = new Date(isoTimestamp);

  return Number.isNaN(parsed.getTime())
    ? UNKNOWN_DATE
    : FORMATTER.format(parsed);
}
